var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackRec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 10.9143C4.66747 8.93316 4.66747 2.86688 0.40039 0.885736C5.23319 1.62761 10.1907 1.7732 15.0575 1.30359C11.6671 3.43005 11.6671 8.36999 15.0575 10.4964C10.2302 9.56486 5.25761 9.7 0.488024 10.8924L0.400391 10.9143Z",
    fill: "#201C25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRec);
export default __webpack_public_path__ + "static/media/blackRec.753a9393a2e350b6c959090f1553f83f.svg";
export { ForwardRef as ReactComponent };